// QueryClientProvider moved to src/main.tsx
import { Route, Routes, useLocation } from 'react-router-dom';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import GlobalProvider from './components/GlobalProvider';
import MainAppBar from './components/MainAppBar';
import MainDrawer from './components/MainDrawer';
import MainRouter from './components/MainRouter';
import KioskNotificationComponent from './pages/kiosksNotification/KiosksNotificationComponent';
import LoginPage from './pages/LoginPage';
import RootRedirect from './pages/RootRedirect';
import VisioComponent from './pages/visio/VisioComponent';
import { ROUTES } from './utils/constants/routes.constants';

const App = () => {
    const location = useLocation();

    const hideBarAndDrawer = location.pathname === ROUTES.LOGIN;
    return (
        <LocalizationProvider dateAdapter={AdapterLuxon}>
            <GlobalProvider>
                {!hideBarAndDrawer && ( // Only show these on logged in pages
                    <>
                        <MainAppBar />
                        <MainDrawer />
                    </>
                )}
                <div
                    style={{
                        paddingTop: hideBarAndDrawer ? 0 : '72px',
                        paddingLeft: hideBarAndDrawer ? 0 : '256px',
                    }}
                >
                    <Routes>
                        <Route path={ROUTES.ROOT} element={<RootRedirect />} />
                        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
                    </Routes>
                    <KioskNotificationComponent />
                    <VisioComponent />
                    <MainRouter />
                </div>
            </GlobalProvider>
        </LocalizationProvider>
    );
};

export default App;
